/**
 * Señal "enfocar el buscador" — la tecla `i` (listener global en
 * SantaColomaMapView) pone `open` a true y SearchBox lo consume enfocando
 * su input y volviéndolo a false. Antes abría una consola propia
 * (CommandConsole, "Ir a regulador"), sustituida por el buscador del header.
 */
import { create } from 'zustand';

interface CommandConsoleState {
  open: boolean;
  toggle: () => void;
  close: () => void;
}

export const useCommandConsole = create<CommandConsoleState>(set => ({
  open: false,
  toggle: () => set(s => ({ open: !s.open })),
  close: () => set({ open: false }),
}));
